import { render } from "./DynamicTagField.vue?vue&type=template&id=df4b416c"
import script from "./DynamicTagField.vue?vue&type=script&lang=js"
export * from "./DynamicTagField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__